// ======================================================================
// Forge Lite | hello@hashandsalt.com
// ======================================================================

// window.$ = window.jQuery = require('jquery');

// ======================================================================
// Modules
// ======================================================================

// require any further scripts here ie:
// require('npmpackagename');
// require('./mylocalfile.js');

import Tobii from "@midzer/tobii";

const tobii = new Tobii();

import { lazyLoad } from 'unlazy'

// Apply lazy loading for all images by the selector `img[loading="lazy"]`
lazyLoad()

function textFade() {
  var list = document.querySelector(".text-section .splitcontent");
  if (list) {
    const observerOptions = {
      root: null,
      threshold: 0,
      rootMargin: "0px 0px -12px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("text-in-view");
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    window.addEventListener("DOMContentLoaded", (event) => {
      let sections = Array.from(
        document.querySelectorAll(
          "header :is(h1,h2,p), .splitcontent :is(dl,p,h1,h2,h3,figure,a,button,hr), .teamember :is(dl,p,h1,h2,h3,figure,a,button,hr)"
        )
      );
      // console.log(sections);

      for (let section of sections) {
        observer.observe(section);
      }
    });
  }
}

function init() {
  textFade();
}

document.addEventListener("DOMContentLoaded", (event) => {
  init();
});
